/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponseFromDiscriminatorValue, serializeWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest, serializeWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse, type WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest, type WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/domain-subscription-payment-interval
 */
export interface DomainSubscriptionPaymentIntervalRequestBuilder extends BaseRequestBuilder<DomainSubscriptionPaymentIntervalRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse>}
     */
     put(body: WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DomainSubscriptionPaymentIntervalRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/domain-subscription-payment-interval";
/**
 * Metadata for all the requests in the request builder.
 */
export const DomainSubscriptionPaymentIntervalRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: DomainSubscriptionPaymentIntervalRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
